export const styles = {
    dividerWrapper: {
        width: '100%',
    },
    divider: {
        borderColor: '#C1C4CC !important',
        marginBottom: '24px',
    },
    removeButtonBox: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    removeButton: {
        color: '#7C85A2',
    },
};
